import { createContext, FC, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  persistirProyecto,
  putResultadoById,
  registrarUserInput,
} from "../../../controllers/operaciones";
import { useProyecto } from "../../../data/ProyectoContext";
import { useAuthContext } from "../../../hooks/Auth";
import { useOrganizationContext } from "../../../context/OrganizationContext";
import { DataObjetivosPorNivel } from "../../../interfaces/DataObjetivosPorNivel";
import { ActividadesContextProps } from "../../../interfaces/UmmiaApps/ActividadesContextProps";
import {
  getObjetivosAprendizajePorNivel,
  post_minimal_api, post_api_mm
} from "../../../services/api";
import OpenMarkdownPreview from "../../../utils/openMarkdownPreview";
import { iDataComponentes } from "../../../interfaces/SuperAdmin/Others/iDataComponentes";
import ConfirmDialog from "../../utils/ConfirmDialog";
import { DataUserMinimalAPIPayload } from "../../../interfaces/DataUserMinimalAPIPayload";
import { iUser } from "../../../interfaces/Auth/iUser";
import axios from "axios";
import { toast } from "react-toastify";
import type { FormattedNivelTP } from "../../../data/GetNivelesTP";

interface StateProyectoResultado {
  proyectoId: string;
  resultadoId: string;
}

const ActividadesContext = createContext<ActividadesContextProps>(
  {} as ActividadesContextProps
);

interface Props {
  children: React.ReactNode;
}

const ActividadesProvider: FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const { proyecto, setProyecto } = useProyecto();
  const { user, updateCreditInfo } = useAuthContext();
  const { selectedOrgId, refreshCredits } = useOrganizationContext();



  // Estados base
  const [objetivosDeAprendizajePorNivel, setObjetivosDeAprendizajePorNivel] =
    useState<DataObjetivosPorNivel[]>([]);
  const [gradoId, setGradoId] = useState<number | undefined>(undefined);
  const [materiaId, setMateriaId] = useState<string>("");
  const [objetivosSeleccionados, setObjetivosSeleccionados] = useState<
    Record<string, boolean>
  >({});
  const [mostrarCamposAvanzados, setMostrarCamposAvanzados] = useState(false);

  // Estados de UI
  const [cargando, setCargando] = useState(false);
  const [primerLlamadoAPI, setPrimerLlamadoAPI] = useState(true);
  const [respuestaGenerada, setRespuestaGenerada] = useState(false);
  const [mostrarCampos, setMostrarCampos] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [respuestaAPI, setRespuestaAPI] = useState<string>("");
  const [respuestaImg, setRespuestaImg] = useState<string>("");
  const [respuestaEditable, setRespuestaEditable] = useState<string>("");
  const [objProyectoResultadoId, setObjProyectoResultadoId] =
    useState<StateProyectoResultado>({} as StateProyectoResultado);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [textoInicial, setTextoInicial] = useState<string | null>(null);
  const location = useLocation();
  const [formData, setFormData] = useState<any>({});
  const [isOAAdded, setIsOAAdded] = useState(false);
  const [nivelId, setNivelId] = useState<string | null>(null);
  const [nivelTPId, setNivelTPId] = useState<string>("");
  const [asignaturaTPId, setAsignaturaTPId] = useState<string>("");
  const [especialidadTP, setEspecialidadTP] = useState<{ id: string; nombre: string } | null>(null);

  const [isPersist, setIsPersist] = useState(false);
  const { pathname } = useLocation();
  const esABP = pathname === "/asistente/abp";
  const [persistenciaHabilitada, setPersistenciaHabilitada] = useState(!esABP);
  const [lastPayload, setLastPayload] = useState<DataUserMinimalAPIPayload | null>(null);

  //Estados para el modal de confirmación
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogMessage, setConfirmDialogMessage] = useState("");
  const [confirmDialogTitle, setConfirmDialogTitle] = useState("");
  const [onConfirmDialog, setOnConfirmDialog] = useState<() => void>(() => { });
  const [selectedApp, setSelectedApp] = useState<iDataComponentes | null>(null);

  // Estado principal del formulario
  const [promptData, setPromptData] = useState<any>({});
  const [envoltorio, setEnvoltorio] = useState<string>();
  const [prevPromptData, setPrevPromptData] = useState<any>({});
  const [isNotEnoughOpen, setIsNotEnoughOpen] = useState(false);


  // Estado para almacenar el id del proyecto creado
  const [idProyecto, setIdProyecto] = useState<string | null>(null);

  // Estado para almacenar el id del resultado creado
  const [resultadoId, setResultadoId] = useState<string | null>(null);

  // Efectos

  useEffect(() => {
    // console.log('promptData actualizado:', promptData);
    setPrevPromptData(promptData);
  }, [promptData]);

  useEffect(() => {
    const esABP = location.pathname === "/asistente/abp";
    setPersistenciaHabilitada(!esABP);
    setIsPersist(false);
  }, [location.pathname]);

  //Efecto para determinar si promptData en nivel o materia tienen datos
  useEffect(() => {
    if (pathname === "/asistente/abp") {
      setIsPersist(false);
      return;
    }

    if (!persistenciaHabilitada) {
      setIsPersist(false);
      return;
    }

    const materia = promptData?.materia || "";
    const nivel = promptData?.nivel || "";
    const hasSelectedField = materia.trim() !== "" || nivel.trim() !== "";
    setIsPersist(hasSelectedField);
  }, [promptData, persistenciaHabilitada, pathname]);

  useEffect(() => {
    if (pathname === "/asistente/abp") {
      setPromptData({});
      setPrevPromptData({});
    }
  }, [pathname]);

  useEffect(() => {
    console.log(objetivosSeleccionados);
  }, [objetivosSeleccionados]);

  useEffect(() => {
    //Aqui se puede obtener el pais del usuario y pasar el parametro pais al endpoint
    console.log("Pais del usuario", user?.pais);
    if (gradoId) {
      const fetchObjetivosAprendizaje = async () => {
        const response = await getObjetivosAprendizajePorNivel(gradoId);
        setObjetivosDeAprendizajePorNivel(response.data);
      };
      fetchObjetivosAprendizaje();
    }
  }, [gradoId]);

  useEffect(() => {
    console.log("location.pathname cambió a:", location.pathname);
    // Se ejecuta cada vez que cambia la ruta
    resetStates();
  }, [location.pathname]);

  useEffect(() => {
    if (formData) {
      console.log({ formData });
      // Se combinan los datos: si hay claves repetidas, se toma el valor de prevPromptData.
      setPromptData((prev: any) => {
        // 1) Extraigo únicamente lo que quiero conservar de prev
        const { materia_cn, nivel_cn, objetivos_aprendizaje_cn, materia_org, materia_org_id, materia_org_id_nivel_asignatura, nivel_org, nivel_org_id, objetivos_aprendizaje_org, especialidad_tp, especialidad_tp_id, nivel_tp, materia_tp, objetivos_aprendizaje_tp } = prev;

        // 2) Devuelvo un objeto nuevo con SOLO esos tres + lo que llegue en formData + idioma
        return {
          materia_cn,
          nivel_cn,
          objetivos_aprendizaje_cn,
          materia_org,
          materia_org_id,
          materia_org_id_nivel_asignatura,
          nivel_org,
          nivel_org_id,
          objetivos_aprendizaje_org,
          especialidad_tp,
          especialidad_tp_id,
          nivel_tp,
          materia_tp,
          objetivos_aprendizaje_tp,
          ...formData,
          idioma: "español",
        };
      });
    }
  }, [formData]);

  // Función para fusionar la nueva data con los datos previos (prevPromptData)
  // Solo se considerarán las claves que vienen en data; si se repite, se usará el valor de prevPromptData.
  const mergeFormData = (data: any, prevData: any) => {
    const merged: any = { ...data };
    Object.keys(data).forEach((key) => {
      if (prevData && prevData[key] !== undefined) {
        // Si la clave existe en ambos, se sobrescribe con lo que hay en prevData.
        merged[key] = prevData[key];
      }
    });
    return merged;
  };

  // handleInitialPromptData: recibe nueva data y envoltorio; combina la nueva data con lo previamente almacenado en prevPromptData.
  const handleInitialPromptData = (data: any, envoltorio: string) => {
    console.log("data", data);

    // Fusionamos: solo las claves definidas en data se tendrán en cuenta; si alguna de ellas ya estaba en prevPromptData, se sobrescribe con ese valor.
    const mergedData = mergeFormData(data, prevPromptData);
    setFormData(mergedData);
    setEnvoltorio(envoltorio);
  };

  // Manejadores de eventos

  const confirmarCambioModal = (campo: "grado" | "materia", onConfirm: () => void) => {
    if (!persistenciaHabilitada) return;

    const mensaje =
      campo === "grado"
        ? "Cambiar de grado eliminará los objetivos seleccionados. ¿Deseas continuar?"
        : "Cambiar de materia eliminará los objetivos seleccionados. ¿Deseas continuar?";

    setConfirmDialogTitle("Confirmar cambio");
    setConfirmDialogMessage(mensaje);
    setOnConfirmDialog(() => onConfirm);
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogAccept = () => {
    onConfirmDialog(); // Ejecutar la lógica que venía tras confirmar
    setConfirmDialogOpen(false);
  };

  const handleConfirmDialogCancel = () => {
    setConfirmDialogOpen(false);
  };

 

  // Callback para actualizar promptData con el nivel
  const handleNivelChange = (nivelNombre: string, nivelId: any) => {
    const yaHabiaNivel = !!promptData.nivel;
    const hayObjetivosSeleccionados =
      (promptData.objetivos?.length || 0) > 0 ||
      (proyecto.objetivos_aprendizaje_cn?.length || 0) > 0;

    const ejecutarCambio = () => {
      setPromptData((prev: any) => ({
        ...prev,
        nivel_cn: nivelNombre,
        nivel_org: prev.nivel_org || "",
        nivel_tp: ""
      }));
      setProyecto((prev: any) => ({
        ...prev,
        //nivel_curso: nivelNombre,
        nivel_curso_cn: nivelNombre,
        nivel_curso_org: prev.nivel_org || "",
        nivel_curso_tp: "",
        usuario: user,
      }));
      setObjetivosSeleccionados({});
      setIsOAAdded(false);
      setNivelId(nivelId);
    };

    if (!esABP && persistenciaHabilitada && yaHabiaNivel && hayObjetivosSeleccionados) {
      confirmarCambioModal("grado", ejecutarCambio);
    } else {
      ejecutarCambio();
    }
  };

  const handleNivelChangeABP = (nivelNombre: string, nivelId: any) => {
    setPromptData((prev: any) => ({
      ...prev,
      nivel: nivelNombre,
      objetivos: []
    }));

    setProyecto((prev: any) => ({
      ...prev,
      nivel_curso_cn: nivelNombre,
      nivel_curso_org: prev.nivel_curso_org || "",
      nivel_curso_tp: "",
      usuario: user,
    }));

    setObjetivosSeleccionados({});
    setIsOAAdded(false);
    setNivelId(nivelId);
  };



  // --- Helpers TP ---
  const clearTP = () => {
    setEspecialidadTP(null);
    setNivelTPId("");
    setAsignaturaTPId("");
  };

  const handleEspecialidadTPChange = (esp: { id: string; nombre: string } | null) => {
    setEspecialidadTP(esp);

    // Al cambiar especialidad: limpiar nivel y asignatura
    setNivelTPId("");
    setAsignaturaTPId("");
  };

  const handleNivelTPChange = (nivel: FormattedNivelTP) => {
    const nextId = nivel?.id ?? "";

    setNivelTPId(nextId);

    // Al cambiar nivel: limpiar asignatura
    setAsignaturaTPId("");
  };

  const handleAsignaturaTPChangeLocal = (asignatura: { id: string; nombre: string } | null) => {
    setAsignaturaTPId(asignatura?.id ?? "");
  };

  // Ejemplo de callback para asignatura 
  const handleAsignaturaChangeLocal = (asignatura: any) => {
    const yaHabiaMateria = !!promptData.materia;
    const hayObjetivosSeleccionados =
      (promptData.objetivos?.length || 0) > 0 ||
      (proyecto.objetivos_aprendizaje_cn?.length || 0) > 0;

    const ejecutarCambio = () => {
      setPromptData((prev: any) => ({
        ...prev,
        materia_cn: asignatura.nombre,
        materia_org: prev.materia_org || "",
        materia_tp: ""
      }));
      setProyecto((prev: any) => ({
        ...prev,
        materias_cn: [asignatura.nombre],
        materias_org: prev.materias_org || [],
        materias_tp: []
      }));
      setMateriaId(asignatura.id);
      setObjetivosSeleccionados({});
      setIsOAAdded(false);
    };

    if (!esABP && persistenciaHabilitada && yaHabiaMateria && hayObjetivosSeleccionados) {
      confirmarCambioModal("materia", ejecutarCambio);
    } else {
      ejecutarCambio();
    }
  };

  const handleAsignaturaChangeLocalABP = (asignatura: any) => {
   

    setPromptData((prev: any) => {
      const nuevaMateria = asignatura.nombre;

      const prevCN = Array.isArray(prev.materias_cn) ? prev.materias_cn : [];
      const nextCN = prevCN.includes(nuevaMateria) ? prevCN : [...prevCN, nuevaMateria];

      // Si aún hay partes que usan prev.materias, lo mantienes sincronizado
      const prevLegacy = Array.isArray(prev.materias) ? prev.materias : [];
      const nextLegacy = prevLegacy.includes(nuevaMateria) ? prevLegacy : [...prevLegacy, nuevaMateria];

      return {
        ...prev,
        materia: nuevaMateria,     // cursor UI
        materias_cn: nextCN,       // fuente correcta para CN
        materias: nextLegacy,      // compatibilidad (si aún se usa)
      };
    });

    setProyecto((prev: any) => {
      const nuevaMateria = asignatura.nombre;

      const prevCN = Array.isArray(prev.materias_cn) ? prev.materias_cn : [];
      const nextCN = prevCN.includes(nuevaMateria) ? prevCN : [...prevCN, nuevaMateria];

      return {
        ...prev,
        materias_cn: nextCN,
        materias_tp: [],
        materias_org: prev.materias_org || []
      };
    });



    setMateriaId(asignatura.id);
    setIsOAAdded(false); // puedes mantener esto si se usa para validar envío
  };


  const handleAsignaturaChange = (asignatura: any) => {
    setMateriaId(asignatura.id);
    setPromptData((prev: any) => ({
      ...prev,
      materia_cn: asignatura.nombre,
      materia_org: prev.materia_org,
      materia_tp: ""
    }));
    setProyecto((prev: any) => ({
      ...prev,
      materias: [asignatura.nombre],
    }));
  };

  const handleGradoChange = (grado: any) => {
    setGradoId(grado.id);
    setPromptData((prev: any) => {
      if (prev.nivel === grado.nombre) return prev;
      return { ...prev, nivel: grado.nombre };
    });
  };

  const handlePersistirData = async (
    data: string,
    proyectoId: string,
    promptData: any,
    promptLLM: string
  ) => {
    if (!envoltorio) {
      throw new Error("Envoltorio no definido");
    }

    if (!user) {
      throw new Error("Usuario no definido");
    }

    const {
      nivel,
      materia,
      tema_evaluacion,
      tipo_evaluacion,
      tema_clase,
      tema,
      tema_problematica,
      titulo,
      tema_taller,
    } = promptData;
    const nombreActividad =
      tema_evaluacion ||
      tipo_evaluacion ||
      tema_clase ||
      tema ||
      tema_problematica ||
      titulo ||
      tema_taller;
    const propuestaUsuario = {
      nivel_curso: nivel,
      nombre: nombreActividad,
      materias: materia,
    };
    //Ahora persistimos el id de proyecto que es enviado desde el backend python
    const respuesta = await persistirProyecto(
      user.id,
      selectedOrgId ?? user.id_organizacion,
      proyectoId,
      propuestaUsuario,
      envoltorio,
      data,
      promptLLM
    );
    console.log("[DEBUG] Respuesta persistirProyecto", respuesta);

    if (respuesta) {
      const { proyectoId, resultadoId } = respuesta;
      setIdProyecto(proyectoId);
      setResultadoId(resultadoId);
      setObjProyectoResultadoId({ proyectoId, resultadoId });
      await registrarUserInput(proyectoId, promptData);
    }
  };

  const handlePutData = async (respuestaEditableData: string) => {
    const { proyectoId, resultadoId } = objProyectoResultadoId;
    console.log({ proyectoId, resultadoId });
    await putResultadoById(proyectoId, resultadoId, {
      resultado: respuestaEditableData,
    });
  };

  const MM_ENVELOPES = new Set([
    'mini_teatro_lectura',
    'desafio_rapido',
    'lectura_eco_y_coro',
    'caza_errores',
    'busqueda_lectores',
    'radio_familiar',
  ]);

  //Handle para generar post y persistir respuesta en db
  const handleGenerate = async () => {
    try {
      if (!envoltorio) throw new Error("Envoltorio no definido");
      if (Object.keys(promptData).length === 0) throw new Error("promptData está vacío");
      if (!user || !selectedApp) return;

      setCargando(true);
      const { roles, categories, ummiapps, ...usuarioSinCampos } = user;

      const payload: DataUserMinimalAPIPayload = {
        usuario: {
          ...usuarioSinCampos as unknown as iUser,
          id_organizacion: selectedOrgId ?? usuarioSinCampos.id_organizacion as unknown as string,
        },
        datos_generales: promptData,
        envoltorio,
        ummiappId: selectedApp.id_componente,
        ummiappNombre: selectedApp.nombre
      };

      setLastPayload(payload);

      // Validación de créditos
      if (user.creditosDisponibles < selectedApp.valor_creditos) {
        setIsNotEnoughOpen(true);
        return;
      }

      // Escoge la función según el envoltorio
      let response;
      if (MM_ENVELOPES.has(envoltorio)) {
        response = await post_api_mm(payload);
      } else {
        response = await post_minimal_api(payload);
      }

      console.log("Respuesta de la API:", response);
      if (response.status === 200) {
        const datos = response.data;
        setRespuestaAPI(datos.respuesta);
        setRespuestaImg(datos.image);
        setRespuestaEditable(datos.respuesta);
        setEditMode(true);
        setRespuestaGenerada(true);
        setMostrarCampos(false);

        const { respuesta, proyectoid, prompt } = datos;
        setIdProyecto(proyectoid);
        await handlePersistirData(respuesta, proyectoid, promptData, prompt);
        await refreshCredits();
        setPrimerLlamadoAPI(false);
      }

    } catch (error) {
      console.error("Error al generar:", error);
    } finally {
      setCargando(false);
    }
  };


  //Función volver
  const handleBack = () => {
    navigate(-1);
    setRespuestaAPI("");
    setRespuestaImg("");
    setRespuestaEditable("");
    setRespuestaGenerada(false);
    setMostrarCampos(true);
    setMostrarCamposAvanzados(false);
    setPrimerLlamadoAPI(true);
    setEditMode(false);
    setTextoInicial(null);
  };

  const copiarAlPortapapeles = () => {
    navigator.clipboard
      .writeText(respuestaAPI)
      .then(() => {
        setSnackbarMessage("Texto copiado al portapapeles");
      })
      .catch((err) => {
        console.error("Error al copiar texto: ", err);
        setSnackbarMessage("Error al copiar al portapapeles");
      });
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
    if (!editMode) {
      setRespuestaEditable(respuestaAPI);
    }
  };


  const handleSaveEdit = async () => {
    setRespuestaAPI(respuestaEditable);
    await handlePutData(respuestaEditable);
    setEditMode(false);

  };

  const toggleCamposAvanzados = () => {
    setMostrarCamposAvanzados(!mostrarCamposAvanzados);
  };

  const toggleVista = () => {
    setMostrarCampos(!mostrarCampos);
  };

  const openMarkdownPreview = () => {
    return OpenMarkdownPreview({ data: respuestaAPI, respuestaImg });
  };

  const handleUploadToSchoology = async () => {
    setCargando(true);
    console.log("User", user);
    const baseUrl = process.env.REACT_APP_API_LTI_SCHOOLOGY;
    if (!baseUrl) {
      console.error("REACT_APP_API_LTI_SCHOOLOGY no está definida");
      return;
    }
    try {
      const body = {
        mdText: respuestaAPI,
        cursoId: user?.ltiContext?.context.courseId
      }

      const response = await axios.post(`${baseUrl}/lti/schoology/page`, body);
      if (response.status === 200) {
        console.log("Respuesta:", response.data);
        toast.success("El contenido fue cargado correctamente en Schoology");
      }
      setCargando(false);

    } catch (error) {
      setCargando(false);
      console.error("Error subiendo a Schoology:", error);
      toast.error("No fue posible cargar contenido en Schoology");
    }
  }

  // Función para limpiar estados
  const resetStates = () => {
    
    setMostrarCamposAvanzados(false);
    setRespuestaAPI("");
    setRespuestaImg("");
    setRespuestaEditable("");
    setRespuestaGenerada(false);
    setMostrarCampos(true);
    setEditMode(false);
    setCargando(false);
    setPrimerLlamadoAPI(true);
    setSnackbarMessage("");
  };

  const changeApp = (app: iDataComponentes | null) => {
    setSelectedApp(app);
  };

  useEffect(() => {
    console.log(selectedApp);
  }, [selectedApp]);

  return (
    <>
      <ActividadesContext.Provider
        value={{
          // Estados
          objetivosDeAprendizajePorNivel,
          nivelId,
          gradoId,
          materiaId,
          especialidadTP,
          nivelTPId,
          asignaturaTPId,
          objetivosSeleccionados,
          mostrarCamposAvanzados,
          cargando,
          primerLlamadoAPI,
          respuestaGenerada,
          mostrarCampos,
          editMode,
          respuestaAPI,
          respuestaImg,
          respuestaEditable,
          promptData,
          snackbarMessage,
          isOAAdded,
          openMarkdownPreview,
          objProyectoResultadoId,
          isPersist,
          persistenciaHabilitada,
          lastPayload,
          selectedApp,
          isNotEnoughOpen,
          idProyecto,
          resultadoId,
          // Setters
          setIdProyecto,
          setResultadoId,
          setObjetivosSeleccionados,
          setLastPayload,
          setPromptData,
          setRespuestaEditable,
          setSnackbarMessage,
          setEnvoltorio,
          setIsOAAdded,
          setIsPersist,
          setNivelId,
          setPersistenciaHabilitada,
          setIsNotEnoughOpen,


          // Handlers
          clearTP,
          handleNivelChange,
          handleNivelTPChange,
          handleEspecialidadTPChange,
          handleAsignaturaTPChangeLocal,
          handleAsignaturaChangeLocal,
          handleNivelChangeABP,
          handleAsignaturaChangeLocalABP,
          handleAsignaturaChange,
          handleGradoChange,
          handleGenerate,
          handleBack,
          handleEditToggle,
          handleSaveEdit,
          toggleCamposAvanzados,
          toggleVista,
          copiarAlPortapapeles,
          textoInicial,
          setTextoInicial,
          handleInitialPromptData,
          changeApp,
          handleUploadToSchoology,
          setEspecialidadTP,
          setNivelTPId,
          setAsignaturaTPId,
        }}
      >
        {children}
      </ActividadesContext.Provider>

      <ConfirmDialog
        open={confirmDialogOpen}
        title={confirmDialogTitle}
        description={confirmDialogMessage}
        onConfirm={handleConfirmDialogAccept}
        onCancel={handleConfirmDialogCancel}
      />
    </>
  );
};

const useActividadesContext = () => useContext(ActividadesContext);

export { ActividadesProvider, useActividadesContext };
